import inksolverLogo from "../assets/inksolver-logo.png";

const ONBOARDING_STEPS = [
  { id: "profile", label: "Your profile" },
  { id: "calibration", label: "Calibrate writing" },
  { id: "problem", label: "Try first problem" },
  { id: "journey", label: "Start your journey" }
];

export default function OnboardingProgressHeader({ currentStep, children }) {
  const currentIndex = Math.max(
    0,
    ONBOARDING_STEPS.findIndex((step) => step.id === currentStep)
  );

  return (
    <header className="onboarding-top-bar">
      <div className="onboarding-brand">
        <img src={inksolverLogo} alt="InkSolver" className="brand-logo" />
      </div>
      <div className="onboarding-progress-bar" aria-label="Getting started progress">
        {ONBOARDING_STEPS.map((step, index) => (
          <div className="onboarding-progress-item" key={step.id}>
            {index > 0 && <div className="onboarding-step-line" aria-hidden="true" />}
            <div className={`onboarding-step ${index === currentIndex ? "active" : ""} ${index < currentIndex ? "completed" : ""}`.trim()}>
              <div className="onboarding-step-circle">
                {index < currentIndex ? "\u2713" : index + 1}
              </div>
              <span className="onboarding-step-label">{step.label}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="onboarding-spacer">{children}</div>
    </header>
  );
}
